module.exports = __webpack_public_path__ + "img/shape_green.2ab5de34.png";